import Vue from 'vue'

import { click } from './directives/click'
import { focusable } from '@fmpedia/directives'

Vue.directive('click', click)
Vue.directive('focusable', focusable)
